module.exports = __webpack_public_path__ + "static/Stephanie_Steiner-Jacobi_at_Mosser.0880ebfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/blog/art-in-neighborhoods/Stephanie_Steiner-Jacobi_at_Mosser.jpg
// module id = 475
// module chunks = 107818501498521